import React from 'react';
import { FileText } from 'lucide-react';
import { AnswerQualityHint } from './AnswerQualityHint';

interface Step2Data {
  what_they_do: string;
}

interface Step2WhatTheyDoProps {
  data: Step2Data;
  onChange: (data: Step2Data) => void;
}

export function Step2WhatTheyDo({ data, onChange }: Step2WhatTheyDoProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <FileText className="w-4 h-4" />
          Wat doet jouw bedrijf precies?
        </label>
        <textarea
          value={data.what_they_do}
          onChange={(e) => onChange({ ...data, what_they_do: e.target.value })}
          rows={6}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg resize-none"
          placeholder="We bakken ambachtelijk brood en gebak, 100% natuurlijk zonder toevoegingen. Elke ochtend vers, met lokale ingrediënten. Klanten kunnen online bestellen en we bezorgen binnen 2 uur in de buurt."
          autoFocus
        />
        <AnswerQualityHint length={data.what_they_do.trim().length} />
      </div>
    </div>
  );
}
